import { inject } from 'vue';

export class DependencyInjectionException extends Error {
  name = 'DependencyInjectionException';
  constructor(dependencyName: string) {
    const message = `[DI] ${dependencyName} is not provided!`;
    super(message);
  }
}

export function safeInject<T>(dependencyName: string) {
  const maybeDependency = inject<T>(dependencyName);
  if (!maybeDependency) {
    throw new DependencyInjectionException(dependencyName);
  }
  return maybeDependency;
}
